import React, { useEffect } from 'react';
import { useAppSelector } from '../../store';
import CusLabelSelect from '../material-ui/CusLabelSelect';
import { useTranslation } from 'react-i18next';

export const ENUM_CURRENCY = {
  all: 'all'
};

export default function CurrencySelect({
  id,
  value,
  setValue,
  isChooseAll,
  isRow,
  hideLabel,
  label = 'Currency',
  allText = 'all',
  isVerySmall,
  currencyList,
  multi,
  disabled
}) {
  const { t } = useTranslation();

  const currenciesAll = useAppSelector((state) => state.user.info.currency);
  let currencyOptions = Object.keys(currenciesAll).map((el) => ({ value: el, label: el }));

  if (isChooseAll) {
    currencyOptions.unshift({ label: t(allText), value: ENUM_CURRENCY.all });
  }

  if (currencyList) {
    currencyOptions = currencyList;
  }

  const onChange = (newValues) => {
    try {
      if (multi && isChooseAll) {
        const cusNewValues = newValues.filter((el) => !value.includes(el));
        const newValue = cusNewValues[0];

        if (newValue == ENUM_CURRENCY.all) {
          setValue([ENUM_CURRENCY.all]);
          return;
        } else if (newValue) {
          setValue(newValues.filter((el) => el !== ENUM_CURRENCY.all));
          return;
        }

        setValue(newValues);
        return;
      }
    } catch (e) {
      console.error(e);
    }

    setValue(newValues);
  };

  return (
    <CusLabelSelect
      id={id}
      label={hideLabel ? undefined : label}
      options={currencyOptions}
      value={value}
      onChange={onChange}
      isRow={isRow}
      isVerySmall={isVerySmall}
      disabled={disabled}
      multi={multi}
      selectProps={{ onClick: (e) => e.stopPropagation() }}
    />
  );
}
